'use client'

import { FC, PropsWithChildren } from 'react'
import { YMapComponentsProvider } from 'ymap3-components'

interface IProps extends PropsWithChildren {}

const apiKey = process.env.NEXT_PUBLIC_YMAPS_API_KEY

export const YMapsProvider: FC<IProps> = ({ children }) => {
    return (
        <YMapComponentsProvider
            apiKey={apiKey}
            lang='ru_RU'
        >
            {children}
        </YMapComponentsProvider>
    )
}
